import { useMemo } from 'react'

import useAuth from 'hooks/use-auth'
import {
  disasterRecoveryTestReportsIdGet,
  disasterRecoveryTestReportsPagedGet,
  disasterRecoveryTestsActiveGet,
  disasterRecoveryTestsDraftGet,
  disasterRecoveryTestsIdCompletePost,
  disasterRecoveryTestsIdDelete,
  disasterRecoveryTestsIdGet,
  disasterRecoveryTestsIdHaltAllPost,
  disasterRecoveryTestsIdPut,
  disasterRecoveryTestsIdRunAllPost,
  disasterRecoveryTestsIdServiceRunPost,
  disasterRecoveryTestsPost,
  policiesServiceIdReliabilityReportGet,
  scenariosHaltIdRunsRunNumberPost,
  scenariosIdRunsGet,
  scenariosIdRunsPost
} from 'utils/endpoints-access'

export function useGetDisasterRecoveryTestPermissions() {
  const { hasEndpointAccess, hasEndpointAccessForAll } = useAuth()

  const accessValues = useMemo(() => {
    return {
      canCompleteDisasterRecoveryTests: hasEndpointAccess(
        disasterRecoveryTestsIdCompletePost
      ),
      canCreateDisasterRecoveryTests: hasEndpointAccess(
        disasterRecoveryTestsPost
      ),
      canDeleteDisasterRecoveryTests: hasEndpointAccess(
        disasterRecoveryTestsIdDelete
      ),
      canHaltAllDisasterRecoveryTests: hasEndpointAccess(
        disasterRecoveryTestsIdHaltAllPost
      ),
      canReadDisasterRecoveryTests: hasEndpointAccessForAll([
        disasterRecoveryTestsActiveGet,
        disasterRecoveryTestsDraftGet,
        disasterRecoveryTestsIdGet
      ]),
      canReadDisasterRecoveryTestReports: hasEndpointAccessForAll([
        disasterRecoveryTestReportsIdGet,
        disasterRecoveryTestReportsPagedGet
      ]),
      canRunAllDisasterRecoveryTests: hasEndpointAccess(
        disasterRecoveryTestsIdRunAllPost
      ),
      canUpdateDisasterRecoveryTests: hasEndpointAccess(
        disasterRecoveryTestsIdPut
      ),
      getCanHaltDisasterRecoveryTests: (teamId?: string) =>
        hasEndpointAccess(disasterRecoveryTestsIdHaltAllPost) ||
        (teamId &&
          hasEndpointAccess(scenariosHaltIdRunsRunNumberPost, { teamId })),
      getCanRunDisasterRecoveryTests: (teamId?: string) =>
        hasEndpointAccess(disasterRecoveryTestsIdRunAllPost) ||
        hasEndpointAccess(disasterRecoveryTestsIdServiceRunPost) ||
        (teamId && hasEndpointAccess(scenariosIdRunsPost, { teamId })),
      getCanViewDisasterRecoveryTestServiceRunDetails: (teamId?: string) =>
        hasEndpointAccess(disasterRecoveryTestsIdGet) ||
        (teamId &&
          (hasEndpointAccess(policiesServiceIdReliabilityReportGet, {
            teamId
          }) ||
            hasEndpointAccess(scenariosIdRunsGet, { teamId })))
    }
  }, [hasEndpointAccess, hasEndpointAccessForAll])

  return accessValues
}
